var _path, _path2, _path3, _path4, _path5, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.61,17.47l-1.17-1.33A5.54,5.54,0,0,0,17.29,12h1.77A7.29,7.29,0,0,1,16.61,17.47Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.06,12H17.29a5.59,5.59,0,0,0-1.86-4.16l1.18-1.32A7.35,7.35,0,0,1,19.06,12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19,19.93,17.78,18.6a8.79,8.79,0,0,0,3-6.59h1.77A10.54,10.54,0,0,1,19,19.93Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.51,12H20.74a8.85,8.85,0,0,0-3-6.61L19,4.07A10.65,10.65,0,0,1,22.51,12Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.09,18.51l-1.25-.78c-1.78-1.1-3.79-2.32-4.35-2.63H3.75a2.26,2.26,0,0,1-2.26-2.26V10.61A2.26,2.26,0,0,1,3.75,8.35H8.49c.56-.31,2.57-1.53,4.35-2.63l1.25-.78ZM3.75,10a.61.61,0,0,0-.61.61v2.23a.61.61,0,0,0,.61.61H8.69c.26,0,.34,0,3.75,2.1V7.9C9,10,9,10,8.69,10Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.19,
    y: 14.4,
    width: 1.65,
    height: 5.52
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletinIcon);
export default __webpack_public_path__ + "static/media/bulletin_icon.e8137c13279382ece16f6b8169ed3ebe.svg";
export { ForwardRef as ReactComponent };